import styled from '@emotion/styled';
import H4 from '../H4';

export const Title = styled(H4)`
    padding-bottom: 0.5rem;
    margin-bottom: 1rem;
    width: 100%;
    border-bottom: 1px solid ${({ theme }) => theme.greys[50]};
`;
